module.exports = __webpack_public_path__ + "static/media/tab_inactive.d8a6bbda.png";